import api from "../axios";


/*
|--------------------------------------------------------------------------
| LOGIN
|--------------------------------------------------------------------------
*/

export const loginApi = async ({
  email,
  password,
}) => {
  const response = await api.post(
    "/auth/login",
    {
      email,
      password,
    }
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| CURRENT USER
|--------------------------------------------------------------------------
*/

export const getCurrentUserApi = async () => {
  const response = await api.get(
    "/auth/me"
  );

  return response.data;
};


/*
|--------------------------------------------------------------------------
| LOGOUT
|--------------------------------------------------------------------------
|
| JWT authentication is stateless.
| Frontend removes the token.
|--------------------------------------------------------------------------
*/

export const logoutApi = async () => {
  return {
    success: true,
  };
};


/*
|--------------------------------------------------------------------------
| ADMIN - USERS
|--------------------------------------------------------------------------
*/


/*
| GET ALL MANAGED USERS
|
| GET /auth/users
*/

export const getUsersApi = async () => {
  const response = await api.get(
    "/auth/users"
  );

  return response.data;
};


/*
| GET SINGLE USER
|
| GET /auth/users/:id
*/

export const getUserApi = async (id) => {
  const response = await api.get(
    `/auth/users/${id}`
  );

  return response.data;
};


/*
| CREATE USER
|
| POST /auth/users
|
| ADMIN can create:
| - SALES
| - AGENT
*/

export const createUserApi = async (data) => {
  const response = await api.post(
    "/auth/users",
    data
  );

  return response.data;
};


/*
| UPDATE USER
|
| PATCH /auth/users/:id
*/

export const updateUserApi = async (
  id,
  data
) => {
  const response = await api.patch(
    `/auth/users/${id}`,
    data
  );

  return response.data;
};


/*
| CHANGE USER PASSWORD
|
| PATCH /auth/users/:id/password
*/

export const changeUserPasswordApi = async (
  id,
  data
) => {
  const response = await api.patch(
    `/auth/users/${id}/password`,
    data
  );

  return response.data;
};


/*
| DELETE / DEACTIVATE USER
|
| DELETE /auth/users/:id
*/

export const deleteUserApi = async (id) => {
  const response = await api.delete(
    `/auth/users/${id}`
  );

  return response.data;
};